import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import useLanguage from '../../../../hooks/useLanguage';
import ArrowLeft from '../../../../svg/arrow_left.svg';
import ArrowRight from '../../../../svg/arrow_right.svg';

const PaginationArrow = ({pageContext}) => {
  const {next, previous} = pageContext
  const langToggle = useLanguage;
  return (
    <div className="article__navigation-wrapper" data-scroll-section>
      <div className="content-wrapper">
        <div className="article__navigation">
          <Link            
            to={previous ? '/blog/' + previous.slug : '#'}
            className={previous ? "article__navigation-link article__navigation-link__prev is-active" : "article__navigation-link article__navigation-link__prev"}
          >
            <span className="article__navigation-icon article__navigation-icon__prev">
              <ArrowLeft className="article__navigation-icon__arrow" />
            </span>
            <span className="article__navigation-title">
              {langToggle('Попередня стаття', 'Предыдущая статья')}
            </span>
          </Link>
          <Link
            to={next ? '/blog/' + next.slug : '/'}
            className={next ? "article__navigation-link article__navigation-link__next is-active" : "article__navigation-link article__navigation-link__next"}
          >
            <span className="article__navigation-title">
              {langToggle('Наступна стаття', 'Следующая статья')}
            </span>
            <span className="article__navigation-icon article__navigation-icon__next">
              <ArrowRight className="article__navigation-icon__arrow" />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

PaginationArrow.propTypes = {
  textLeft: PropTypes.string,
  textRight: PropTypes.string,
};

export default PaginationArrow;
